import { useCallback } from 'react'

type NavigateOptions<T> = {
  search: T
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type NavigateFn<T> = (options: NavigateOptions<T>) => any

/**
 * ページ変更時のナビゲーション処理を行うフック
 * @param search 現在の検索条件
 * @param navigate ナビゲーション関数
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const usePageNavigation = <T extends Record<string, any>>(
  search: T,
  navigate: NavigateFn<T>
) => {
  const handlePageChange = useCallback(
    (page: number, pageSize: number) => {
      navigate({
        search: {
          ...search,
          page,
          take: pageSize
        }
      })
    },
    [search, navigate]
  )

  return handlePageChange
}
